module.exports = __webpack_public_path__ + "images/4252b7bb49f1b5263791e7f4cf78e601-illu_key_logo.png";